import { render, staticRenderFns } from "./MediumContent.vue?vue&type=template&id=faf607c2&scoped=true"
import script from "./MediumContent.vue?vue&type=script&lang=js"
export * from "./MediumContent.vue?vue&type=script&lang=js"
import style0 from "./MediumContent.vue?vue&type=style&index=0&id=faf607c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf607c2",
  null
  
)

export default component.exports